<div class="main-wrapper">
  <div class="nav-top-container">
    <app-frms-navbar (toggleEvent)="onToggleEvent($event)"></app-frms-navbar>
  </div>
  <div class="wrapper" [ngClass]="wrapperClass">
    <div class="sidebar-container">
      <app-frms-sidebar #appSidebar ></app-frms-sidebar>
      <div class="sidebar-background" style="background-image: url(../assets/img/sidebar.png)"></div>
    </div>


    <div class="page-content-wrapper">
      <div class="container-fluid container-fluid-reduced">
        <router-outlet></router-outlet>
      </div>
    </div>

  </div>
  <notifier-container></notifier-container>
</div>